import * as modal from "../modal/index";

function resetForm() {
  const formContact = document.getElementById("contact-form");
  const fileInput = document.querySelector("#arquivos");
  const checkTerms = document.querySelector("#check-terms");
  const selectSubject = document.querySelector("#contato-assunto");

  if (!formContact) return;

  formContact.reset();

  if (fileInput) {
    fileInput.value = "";
    const fileLabel = fileInput.parentElement.querySelector(".input-file__name");
    if (fileLabel) fileLabel.innerHTML = "Nenhum arquivo escolhido";
  }

  if (checkTerms) {
    checkTerms.classList.remove("active");
    checkTerms.parentElement?.classList.remove("error-terms");
  }

  if (typeof window.grecaptcha !== "undefined") {
    window.grecaptcha.reset();
  }

  if (selectSubject) {
    const clearBtn = selectSubject.parentElement.querySelector("[data-action='clear']");
    if (clearBtn) clearBtn.click();
  }
}

export function submitContact() {
  const formContact = document.getElementById("contact-form");
  if (!formContact) return;

  const recaptchanMessage = document.getElementById("g-recaptcha-error");
  const subjectSelect = document.querySelector("#contato-assunto");
  const inputFileContainer = document.querySelector("#contact-form-input-file");
  const fileInput = document.querySelector("#arquivos");
  const checkTerms = document.querySelector("#check-terms");

  if (recaptchanMessage) {
    recaptchanMessage.style.display = "none";
    recaptchanMessage.style.color = "red";
  }

  // Exibir ou esconder input de arquivo conforme assunto
  if (subjectSelect) {
    subjectSelect.addEventListener("change", (e) => {
      if (e.target.value === "Enviar currículo") {
        inputFileContainer?.classList.remove("hidden");
      } else {
        if (fileInput) {
          fileInput.value = "";
          const fileLabel = fileInput.parentElement.querySelector(".input-file__name");
          if (fileLabel) fileLabel.innerHTML = "Nenhum arquivo escolhido";
        }
        inputFileContainer?.classList.add("hidden");
      }
    });
  }

  // Toggle termos se existir
  if (checkTerms) {
    checkTerms.addEventListener("click", () => {
      checkTerms.classList.toggle("active");
    });
  }

  async function sendRequest(formData) {
    document.querySelector("#btn-contact")?.classList.add("loading");

    fetch("/actions/utils/contato/enviar-email", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.ok) {
          modal.getModalByTemplate("message-sent.html");
          resetForm();
        } else {
          delete json.ok;

          const mensagensList = [];
          for (let key in json) {
            if (json.hasOwnProperty(key)) {
              for (let keyMensagem in json[key]) {
                mensagensList.push(json[key][keyMensagem]);
              }
            }
          }

          modal.getModalByTemplate("generic-error", {
            title: "Erro ao enviar o email",
            description: mensagensList.join("<br />"),
          });
        }
      })
      .finally(() => {
        document.querySelector("#btn-contact")?.classList.remove("loading");
      });
  }

  formContact.addEventListener("submit", (e) => {
    e.preventDefault();

    const validElement = (element) => {
      if (!element) return true;
      return !element.classList.contains("error");
    };

    const validRecaptcha = () => {
      if (typeof grecaptcha !== "undefined" && grecaptcha.getResponse() === "") {
        if (recaptchanMessage) recaptchanMessage.style.display = "flex";
        return false;
      }
      if (recaptchanMessage) recaptchanMessage.style.display = "none";
      return true;
    };

    const validEntry = () => {
      return (
        validElement(document.querySelector("#contato-nome")) &&
        validElement(document.querySelector("#contato-email")) &&
        validElement(document.querySelector("#contato-telefone")) &&
        validElement(document.querySelector("#contato-celular")) &&
        validElement(document.querySelector("#contato-cidade-estado")) &&
        validElement(document.querySelector("#contato-mensagem")) &&
        validRecaptcha()
      );
    };

    // Validação de termos (se existir)
    if (checkTerms && !checkTerms.classList.contains("active")) {
      checkTerms.parentElement?.classList.add("error-terms");
      return;
    } else {
      checkTerms?.parentElement?.classList.remove("error-terms");
    }

    if (!validEntry()) return;

    const CRAFT_CSRF_NAME = window.csrfTokenName;
    const CRAFT_CSRF_TOKEN = window.csrfTokenValue;

    const formData = new FormData();
    formData.append("nome", document.querySelector("#contato-nome")?.value || "");
    formData.append("email", document.querySelector("#contato-email")?.value || "");
    formData.append("telefone", document.querySelector("#contato-telefone")?.value || "");
    formData.append("celular", document.querySelector("#contato-celular")?.value || "");
    formData.append("cidadeEstado", document.querySelector("#contato-cidade-estado")?.value || "");
    formData.append("assunto", document.querySelector("#contato-assunto")?.value || "");
    formData.append("mensagem", document.querySelector("#contato-mensagem")?.value || "");
    formData.append(CRAFT_CSRF_NAME, CRAFT_CSRF_TOKEN);

    if (
      fileInput &&
      fileInput.value !== "" &&
      document.querySelector("#contato-assunto")?.value === "Enviar currículo"
    ) {
      formData.append("arquivos", fileInput.files[0]);
    }

    sendRequest(formData);
  });
}

if (document.querySelector("#contact-form")) {
  submitContact();
}